/**
 * Paleta categórica do painel. Cada fatia/barra recebe uma cor distinta —
 * monocromático obriga o olho a ler o rótulo para diferenciar, e o pedido é
 * "bati o olho e já sei o que é".
 *
 * Ordem pensada para contraste entre vizinhos, não por matiz.
 */
export const PALETA = [
  '#7aa2f7', // azul
  '#5fe3c0', // menta
  '#e9c46a', // dourado (marca)
  '#b39ddb', // roxo
  '#56e39f', // verde
  '#f2787a', // vermelho
  '#f5b971', // âmbar
  '#8fa3c8', // cinza-azulado
] as const

export function corDaSerie(indice: number): string {
  return PALETA[indice % PALETA.length] as string
}
